import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ButtonComponent } from 'components/input/button/button.component';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { CustomSelectComponent } from 'components/input/custom-select/custom-select.component';
import { InputStateDirective } from 'directives/input-state.directive';
import { InputType } from 'enums/InputType';
import { AdUserModel } from 'models/generated/Identity.Api.Models.AdUser';
import { TeamModel } from 'models/generated/Identity.Api.Models.Team';
import { UserModel } from 'models/generated/Identity.Api.Models.User';
import { UserTeamModel } from 'models/generated/Identity.Api.Models.UserTeam';
import { SelectListItemModel } from 'models/SelectList';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { TranslatePipe } from 'pipes/translate.pipe';
import { UserService } from 'services/user.service';

@Component({
	selector: 'view-user',
	templateUrl: './view-user.component.html',
	imports: [Layout, CustomSelectComponent, CustomInputComponent, ListView, InputStateDirective, TranslatePipe]
})
export class ViewUserComponent {

	@ViewChild('saveButton') saveButton!: ButtonComponent;

	private adUsers: AdUserModel[] = [];
	private activeUsers: UserModel[] = [];

	public inputType = InputType;
	public user?: UserModel;
	public adUserList: SelectListItemModel[] = [];
	public teams: { id: string, name: string, sale: boolean, selected: boolean, wasSelected: boolean }[] = [];
	public savingData = false;
	public checkedSalesTeams: SelectListItemModel[] = [];
	public includeAllAdUsers = false;

	@Input()
	set userId(id: string | undefined) {
		if (id) {
			this.userService.getUserById(id).then(user => {
				this.loadUserModel(user);
			});
		} else {
			this.loadUserModel(new UserModel());
		}
	}
	get userId() {
		return this.user?.id;
	}
	@Output() userIdChange = new EventEmitter<string>();

	constructor(private readonly userService: UserService) { }

	async loadUserModel(user: UserModel) {
		this.checkedSalesTeams = [];
		if (!user.id) {
			this.user = undefined;
			[this.activeUsers, this.adUsers] = await Promise.all([this.userService.getAllActiveUsers(), this.userService.getAllAdUsers()]);
			this.adUsers.sort((a, b) => a.displayName.localeCompare(b.displayName));

			this.filterAdUsers();
		}
		this.user = user;

		let teams = await this.userService.getAllActiveTeams();
		teams.sort((a, b) => a.name.localeCompare(b.name));
		this.teams = teams.map(team => { return { id: team.id!, name: team.name, sale: team.sale, selected: user.userTeams.some(ut => ut.teamId == team.id), wasSelected: user.userTeams.some(ut => ut.teamId == team.id) } });
		this.getCheckedSalesTeams();
	}

	filterAdUsers() {
		this.adUserList = this.adUsers
			.filter(adUser => (this.includeAllAdUsers || this.userService.adUserIsPerson(adUser)) && !this.activeUsers.some(user => user.email == adUser.mail))
			.map(adUser => new SelectListItemModel(adUser.id!, `${adUser.displayName!} (${adUser.mail})`));
	}

	selectAdUser(adUserId: string) {
		var adUser = this.adUsers.find(user => user.id == adUserId);
		if (!adUser || !this.user) return;
		
		this.user.email = adUser.mail!;
		this.user.username = this.getUsernameFromEmail(adUser.mail!);
		this.user.name = adUser.displayName ? adUser.displayName : '';
		this.user.adIdentifier = adUser.id;
	}

	getUsernameFromEmail(email: string) {
		return "DW\\dk" + email.substr(0, 3);
	}

	selectTeam(team: TeamModel) {
		if (!this.user) return;
		team.selected = !team.selected;
		if (team.id == this.user.defaultSalesTeamId) this.user.defaultSalesTeamId = undefined;
		this.user.userTeams = this.teams.filter(team => team.selected).map(team => { return { teamId: team.id, userId: this.user!.id } as UserTeamModel });
		this.getCheckedSalesTeams();
	}

	getCheckedSalesTeams() {
		this.checkedSalesTeams = this.teams.filter(team => team.sale && this.user!.userTeams.filter(ut => ut.teamId == team.id).length > 0).map(team => new SelectListItemModel(team.id, team.name));
	}

	save() {
		if (!this.user) return;
		this.user.include(u => u.userTeams);

		this.userService.updateUser(this.user)
			.then((updatedUser) => {
				this.userIdChange.emit(updatedUser.id!);
				this.saveButton.succeeded();
			})
			.catch(() => this.saveButton.reset());
	}
}

